import { render, staticRenderFns } from "./DevPage.vue?vue&type=template&id=2964b8a7"
import script from "./DevPage.vue?vue&type=script&lang=js"
export * from "./DevPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports